import { css } from "lit";

/**
 * Base styles to be applied to all components within the application.
 */
export const baseStyles = css`
  * {
    box-sizing: border-box;
  }
`;
